import { notification as notify } from 'utils'
import R from 'ramda'

export default function ({ ownerId, values }) {
  const { type: experienceType } = values
  if (
    experienceType === 'INSTAGRAM_COMPETITION' ||
    experienceType === 'FACEBOOK_COMPETITION' ||
    experienceType === 'FACEBOOK_REMINDER' ||
    experienceType === 'FACEBOOK_RECURRING_REMINDER' ||
    experienceType === 'FACEBOOK_COUPON' ||
    experienceType === 'INSTAGRAM_COUPON' ||
    experienceType === 'TWITTER_THREADVENTURE'
  ) {
    return
  }
  const validationError = message => {
    notify.error({
      title: 'Validation Error',
      message
    })
    return { _error: message }
  }

  // A nameless campaign that still holds posts is a half-filled create-new
  // choice; blocking it stops an unnamed campaign reaching widget_data.
  const campaign = R.path(['intentBased', 'campaign'], values)
  const campaignPosts = R.pathOr(
    [],
    ['intentBased', 'campaign', 'posts'],
    values
  )
  if (campaign && campaignPosts.length && !(campaign.name || '').trim()) {
    return validationError('Name the campaign, or remove its posts')
  }

  // A Pulse Intelligence campaign post with no post ID cannot be matched or
  // resolve its permalink for ${missedPostUrl}, so block save.
  const blankPostIndex = campaignPosts.findIndex(
    post => !(post.postId || '').trim()
  )
  if (blankPostIndex !== -1) {
    return validationError(
      `Campaign post ${blankPostIndex + 1} needs a post ID, or remove it`
    )
  }

  const vulnerableTriggers = ['MENTION', 'HASHTAG', 'KEYWORD']

  const isVulnerableTrigger = R.both(
    R.pipe(R.prop('type'), R.contains(R.__, vulnerableTriggers)),
    R.pipe(R.prop('data'), R.isEmpty)
  )

  const isNotVulnerableTrigger = R.complement(isVulnerableTrigger)

  // remove empty trigger data for above mentioned types
  // @param action - the action sets
  const removeEmptyTriggerData = R.map(
    R.evolve({
      triggers: R.filter(isNotVulnerableTrigger)
    })
  )

  values.actions = removeEmptyTriggerData(values.actions)

  const hasPrimaryTriggers =
    values.actions.length &&
    values.actions.every(
      action => action.triggers.length && action.triggers.some(t => t.primary)
    )

  if (!hasPrimaryTriggers) {
    return validationError('You must specify triggers')
  }

  const successActionsMissing = values.actions.some(
    action => !action.success.length
  )

  if (successActionsMissing) {
    return validationError('You must specify actions')
  }

  //  Ensure that if a trigger set contains a hashtag it is combined with a mention
  const getAllTriggers = R.map(action => action.triggers)
  const getTriggerTypes = R.map(trigger => R.pluck('type')(trigger))

  const allTriggers = getAllTriggers(values.actions)
  const triggerTypes = getTriggerTypes(allTriggers)

  let triggerSetsValid = true

  triggerTypes.forEach(triggerTypeSet => {
    const hasHashtag = R.contains('HASHTAG')(triggerTypeSet)
    const hasMention = R.either(
      R.contains('MENTION'),
      R.contains('FROM')
    )(triggerTypeSet)

    if (hasHashtag && !hasMention) triggerSetsValid = false
  })

  if (!triggerSetsValid) {
    return validationError(
      `Trigger sets containing Hashtags must be combined with Mentions or Owner's Tweet in order to save`
    )
  }

  if (!ownerId) {
    return validationError('Widget must have an owner in order to save')
  }
}



// WEBPACK FOOTER //
// ./src/pages/widgets/validation.js